import { useState } from 'react';
import { AxiosError } from 'axios';
import {
  IApplicationAccident,
  IApplicationAccidentParams,
} from 'pages/PageApplicationNew/components/ApplicationAccidentDialog/interfaces';
import { getApplicationAccidentList } from 'pages/PageApplicationNew/components/ApplicationAccidentDialog/api';

export function useGetRealEstateAccidents() {
  const [{ loading, data, error }, setData] = useState<{
    loading: boolean;
    error: string | null;
    data: Map<string, { list: IApplicationAccident[]; totalCount: number }>;
  }>({ loading: false, error: null, data: new Map() });

  const fetchRealEstateAccidents = async (
    realEstateGuid: string,
    params: IApplicationAccidentParams,
    skip: boolean = true,
  ) => {
    const mapKey = Object.values(params).filter(Boolean).join('-');
    if (skip && data.has(mapKey)) return;

    setData((prevState) => ({ ...prevState, loading: true }));

    try {
      const response = await getApplicationAccidentList(realEstateGuid, params);

      setData((prevState) => {
        const newData = new Map(prevState.data);
        newData.set(mapKey, response);
        return { ...prevState, data: newData };
      });
    } catch (error) {
      setData((prevState) => ({ ...prevState, error: (error as AxiosError).response?.data.message }));
    } finally {
      setData((prevState) => ({ ...prevState, loading: false }));
    }
  };

  return { loading, data, error, fetchRealEstateAccidents };
}
